import {AfterViewInit, Directive, ElementRef, OnDestroy, Renderer2} from '@angular/core';

@Directive({
    standalone: true,
    selector: '[appAutoDataLabel]'
})
export class AutoDataLabelDirective implements AfterViewInit, OnDestroy {
    private observer: MutationObserver | undefined;

    constructor(private el: ElementRef, private renderer: Renderer2) {
    }

    ngAfterViewInit() {
        this.applyDataLabels();

        this.observer = new MutationObserver(() => {
            this.applyDataLabels();
        });

        this.observer.observe(this.el.nativeElement, {
            childList: true,
            subtree: true
        });
    }

    ngOnDestroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    private applyDataLabels() {
        const table: HTMLTableElement = this.el.nativeElement;
        const headers: string[] = Array.from(table.querySelectorAll('thead th')).map(th => th.textContent || '');
        const rows: HTMLTableRowElement[] = Array.from(table.querySelectorAll('tbody tr'));

        rows.forEach((row) => {
            const cells: HTMLTableCellElement[] = Array.from(row.querySelectorAll('td'));
            cells.forEach((cell, index) => {
                if (headers[index]) {
                    this.renderer.setAttribute(cell, 'data-label', headers[index]);
                }
            });
        });
    }
}
